'use client';
import { EXIST_LOCAL_STORAGE } from '@/services/constants';
import { getStorage } from '@/services/helperFunctions';
import React, { useMemo } from 'react';
import Heading from './components/bondInfo/Heading';
import InfoItem from './components/bondInfo/InfoItem';

const BondInfo: React.FC<any> = ({
    bondsHeaderDetail,
    bondsDetailData,
    getBondInfo,
    BondInfoData,
    initialBondsHeaderDetail,
    isBondsDetailDataLoader,
    isDisabled,
    isLoggedIn,
}) => {
    const formatDate = (date: string) => {
        const issueDate = date?.substring(0, 10);
        const formatted = issueDate
            ? new Date(issueDate).toLocaleDateString('en-US', {
                  month: 'long', // full month name
                  day: '2-digit',
                  year: 'numeric',
              })
            : '';

        return formatted;
    };

    const isBondInfoLazyLoading = useMemo(() => isBondsDetailDataLoader, [isBondsDetailDataLoader]);

    const bondsHeaderData = Array.isArray(initialBondsHeaderDetail?.data) ? initialBondsHeaderDetail?.data[0] : null;

    const bondInfo = Array.isArray(BondInfoData?.data) ? BondInfoData.data[0] : null;

    const userId = getStorage(EXIST_LOCAL_STORAGE.USER_ID);
    const isLoggedInUser = !!userId;

    return (
        <div className="card col mt-2 border-0">
            <div id="table-bond-descriptions" className="tab-right-details-data overflow-lg-auto">
                <section className="Bond Information">
                    <Heading name="Bond Information" />
                    <table className="table table-description table-borderless">
                        <tbody>
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Issue Type"
                                value={bondInfo?.issue_type}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name="Country"
                                value={bondInfo?.country_name}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Industry"
                                value={bondInfo?.industry}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Region"
                                value={bondInfo?.region}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name="Maturity Date"
                                value={bondInfo?.maturity}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name="Par Value"
                                value={bondInfo?.par_value}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Callable"
                                value={bondInfo?.callable}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Next Call Date"
                                value={bondInfo?.next_call_date?.substring(0, 10)}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name=" Call Type"
                                value={bondInfo?.call_type}
                            />
                            {/* <InfoItem isDisabled={isDisabled} isLoggedIn={isLoggedInUser} isLoading={isBondInfoLazyLoading} name=' Man Opt' value={bondInfo?.man_opt} /> */}
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name=" Call Price (%)"
                                value={bondInfo?.call_price}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Series"
                                value={bondInfo?.series}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Class"
                                value={bondInfo?.class_value}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Maturity Structure"
                                value={bondInfo?.maturity_structure}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name=" Amount Outstanding (mil)"
                                value={
                                    bondInfo?.amount_outstanding_millions ? Number(bondInfo?.amount_outstanding_millions)?.toFixed(2) : ''
                                }
                            />
                        </tbody>
                    </table>
                </section>
                <section className="Coupon Information">
                    <Heading name="Coupon Information" />
                    <table className="table table-description table-borderless">
                        <tbody>
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name="Coupon"
                                value={bondInfo?.coupon}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Coupon Type"
                                value={bondInfo?.coupon_type}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Coupon Frequency"
                                value={bondInfo?.payment_frequency}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="First Coupon Date"
                                value={bondInfo?.first_coupon_date?.substring(0, 10)}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Last Coupon Date"
                                value={bondInfo?.last_coupon_date?.substring(0, 10)}
                            />
                        </tbody>
                    </table>
                </section>
                <section className="Risk Information">
                    <Heading name="Risk Information" />
                    <table className="table table-description table-borderless">
                        <tbody>
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Sinking Fund"
                                value={bondInfo?.sinking_fund}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Security"
                                value={bondInfo?.security}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Subordination"
                                value={bondInfo?.subordination}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Debt Type"
                                value={bondInfo?.debt_type}
                            />
                        </tbody>
                    </table>
                </section>
                <section className="Issuance Information">
                    <Heading name="Issuance Information" />
                    <table className="table table-description table-borderless">
                        <tbody>
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Issue Date"
                                value={bondInfo?.issue_date?.substring(0, 10)}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Dated Date"
                                value={bondInfo?.dated_date?.substring(0, 10)}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                name="Issue Size (mil)"
                                value={bondInfo?.issue_size_millions}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Min. Piece"
                                value={bondInfo?.minimum_piece}
                            />
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn={isLoggedInUser}
                                isLoading={isBondInfoLazyLoading}
                                name="Min. Increment"
                                value={bondInfo?.minimum_increment}
                            />
                        </tbody>
                    </table>
                </section>
                <section className={`About the ${bondsHeaderData?.bond_name || ''} bond (${bondsHeaderData?.isin || ''})`}>
                    <Heading name={`About the ${bondsHeaderData?.bond_name || ''} bond (${bondsHeaderData?.isin || ''})`} isAboutIssuer />
                    <table className="table table-description table-borderless">
                        <tbody>
                            <InfoItem
                                isDisabled={isDisabled}
                                isLoggedIn
                                isLoading={isBondInfoLazyLoading}
                                isSingleColumn
                                // value={`This ${bondsHeaderData?.issuer} ${bondInfo?.issue_type?.toLocaleLowerCase() || ''} has a ${
                                //     bondInfo?.coupon ? bondInfo?.coupon?.toFixed(2) + '%' : 'N/A'
                                // } ${bondInfo?.coupon_type?.toLocaleLowerCase() || 'N/A'} rate coupon paid on a ${
                                //     bondInfo?.payment_frequency?.toLocaleLowerCase() || 'N/A'
                                // } basis. It was issued on ${
                                //     bondInfo?.issue_date ? formatDate(bondInfo?.issue_date?.substring(0, 10)) : 'N/A'
                                // } with an issue size of ${
                                //     bondInfo?.issue_size_millions ? Number(bondInfo?.issue_size_millions)?.toFixed(2) : ''
                                // } million ${bondInfo?.currency || 'N/A'} and matures on ${
                                //     bondInfo?.maturity ? formatDate(bondInfo?.maturity?.substring(0, 10)) : 'N/A'
                                // } with a last coupon date of ${
                                //     bondInfo?.last_coupon_date ? formatDate(bondInfo?.last_coupon_date?.substring(0, 10)) : 'N/A'
                                // }.`}
                            >
                                <>
                                    This {bondsHeaderData?.issuer} {bondInfo?.issue_type?.toLocaleLowerCase() || ''} has a{' '}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>
                                            {isLoggedInUser ? (bondInfo?.coupon ? bondInfo?.coupon?.toFixed(2) + '%' : 'N/A') : 'X.X %'}
                                        </span>
                                    </span>{' '}
                                    {bondInfo?.coupon_type?.toLocaleLowerCase() || 'N/A'} rate coupon paid on a{' '}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>{isLoggedInUser ? bondInfo?.payment_frequency?.toLocaleLowerCase() || 'N/A' : 'XXXX'}</span>
                                    </span>{' '}
                                    basis. It was issued on{' '}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>
                                            {isLoggedInUser
                                                ? bondInfo?.issue_date
                                                    ? formatDate(bondInfo?.issue_date?.substring(0, 10))
                                                    : 'N/A'
                                                : 'MAR 12, 2000'}
                                        </span>
                                    </span>{' '}
                                    with an issue size of{' '}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>
                                            {isLoggedInUser
                                                ? bondInfo?.issue_size_millions
                                                    ? Number(bondInfo?.issue_size_millions)?.toFixed(2)
                                                    : ''
                                                : 'XXX'}
                                        </span>
                                    </span>{' '}
                                    million {''}
                                    {bondInfo?.currency || 'N/A'} and matures on {''}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>
                                            {isLoggedInUser
                                                ? bondInfo?.maturity
                                                    ? formatDate(bondInfo?.maturity?.substring(0, 10))
                                                    : 'N/A'
                                                : 'DEC 9, 2000'}
                                        </span>
                                    </span>{' '}
                                    with a last coupon date of{' '}
                                    <span className={isLoggedInUser ? '' : 'blur-logged-analytics'}>
                                        <span>
                                            {isLoggedInUser
                                                ? bondInfo?.last_coupon_date
                                                    ? formatDate(bondInfo?.last_coupon_date?.substring(0, 10))
                                                    : 'N/A'
                                                : 'FEB 28, 2020'}.
                                        </span>
                                    </span>
                                </>
                            </InfoItem>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
    );
};

export default React.memo(BondInfo);
